import React from "react";
import { Spinner } from "reactstrap";
import PropTypes from "prop-types";



function Loader({ spinner = false }) {
  if (spinner) return <Spinner size="sm" color="light"/>;
  return null;
}

// Loader.propTypes = {
//   spinner: PropTypes.bool,
// };

export default Loader;
// function Loader({ spinner }) {
//   if (spinner) return <Spinner size="sm" color="light" />;
//   return null;
// }

// Loader.propTypes = {
//   spinner: PropTypes.bool,
// };

// export default Loader;
